import React, { FormEvent, useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { fetchPreorderDetails } from '../../../../actions/preorder/preorderDetail'
import { AppState } from '../../../../reducers'
import { PreorderDetailListState } from '../../../../reducers/preorder/preorderDetailList'
import { useTranslation } from 'react-i18next'
import { Paper, Box, Typography, Button, Stack, CircularProgress, Tooltip, IconButton, Chip } from '@mui/material';
import { AttachFile, FileDownloadOutlined, FlakyOutlined, KeyboardReturnOutlined } from '@mui/icons-material';
import { formattedCurrency } from '../../../../utils/StringUtils'
import { useThemeContext } from '../../../../theme/ThemeContext'
import { AdminPreorderDetails } from '../../../HeadSales/AdminPreorders'
import moment from 'moment';
import { ClosePreorderDialog } from '../AdminPreordersClose'
import { CarrierListState } from '../../../../reducers/carrier/carrierList'
import { DeliveryLocationListState } from '../../../../reducers/deliveryLocation/deliveryLocationList'
import { ClientDetailState } from '../../../../reducers/client/clientDetail'
import { fetchCarriers } from '../../../../actions/carrier/carrierList'
import { fetchDeliveryLocations } from '../../../../actions/deliveryLocation/deliveryLocationList'
import { fetchClient } from '../../../../actions/client/clientDetail'
import { preorderNotClosingStatus, statusPreorderNameTranslated } from '../../../Utils/CommonConst'
import { upsertPreorder } from '../../../../actions/preorder/preorderUpsert'
import Preorder from '../../../../models/Preorder'
import { PreorderDataState } from '../../../../reducers/preorder/preorderData'
import { fetchPreorder } from '../../../../actions/preorder/preorder'
import { isAdmin, isManager, SessionState } from '../../../../reducers/auth/session'
import { fetchPrepayment } from '../../../../actions/prepayment/prepaymentDetail'
import { PrepaymentDetailState } from '../../../../reducers/prepayment/prepaymentDetail'
import { DeliveryAreaListState } from '../../../../reducers/deliveryArea/deliveryAreaList'
import { fetchDeliveryAreas } from '../../../../actions/deliveryArea/deliveryAreaList'
import { LogisticWarningListState } from '../../../../reducers/logisticWarning/logisticWarningList'
import { uploadPreorderHoldFile } from '../../../../actions/preorder/preorderHoldUploadFile'
import { uploadPreorderRejectFile } from '../../../../actions/preorder/preorderRejectUploadFile'
import { downloadPreorderFile } from '../../../../actions/preorder/preorderDownloadFile'
import { ProvinceListState } from '../../../../reducers/province/provinceList'
import { fetchProvinces } from '../../../../actions/deliveryLocation/provinceList'
import { LocalityListState } from '../../../../reducers/locality/localityList'
//import { fetchLocalities } from '../../../../actions/deliveryLocation/localityList'
import { getToken } from '../../../../utils/fetchApi'
import { IncotermsListState } from '../../../../reducers/incoterms/incotermsList'



interface Props {
  preorderDetail: PreorderDetailListState
  preorderData: PreorderDataState
  carrierList: CarrierListState
  prepayment: PrepaymentDetailState
  provinceList: ProvinceListState
  localityList: LocalityListState
  deliveryLocationList: DeliveryLocationListState
  deliveryAreaList: DeliveryAreaListState
  logisticWarningList: LogisticWarningListState
  incotermsList: IncotermsListState
  client?: ClientDetailState
  session?: SessionState
}


const AdminPreorderDetail: React.FC<Props> = ({ preorderDetail, preorderData, prepayment, carrierList, deliveryLocationList, deliveryAreaList, logisticWarningList, incotermsList, provinceList, localityList, client, session }) => {
  const [showCloseDialog, setShowCloseDialog] = useState<boolean>(false)
  const [currentPreorder, setCurrentPreorder] = useState<Preorder | undefined>(preorderData.preorder!)
  const [fetchingUploadFile, setFetchingUploadFile] = useState<boolean>(false)
  const [downloading, setDownloading] = useState<string>('')

  const dispatch = useDispatch()
  const params = useParams<{ preorderId: string, clientId?: string }>()
  const history = useHistory()
  const { t } = useTranslation(['preorder', 'others'])
  const { theme } = useThemeContext()

  useEffect(() => {
    dispatch(fetchPreorderDetails(params.preorderId, undefined, history.location.search))
    dispatch(fetchPreorder(params.preorderId, (response) => dispatch(fetchClient(response.clientId.toString()))))
  }, [dispatch, params.preorderId, params.clientId, history.location.search])

  useEffect(() => {
    if ((preorderDetail && !preorderDetail.isFetching && preorderDetail.preorderDetail && preorderDetail.preorderDetail.length > 0 && preorderDetail.preorderDetail[0].preorder) ||
      (preorderDetail && !preorderDetail.isFetching && preorderDetail.preorderDetail && preorderDetail.preorderDetail.length === 0 &&
        preorderData && !preorderData.isFetching && preorderData.preorder)) {
      dispatch(fetchProvinces('?all=true'))
      dispatch(fetchCarriers('?all=true'))
      dispatch(fetchDeliveryAreas('?all=true'))
      if (preorderDetail && preorderDetail.preorderDetail && preorderDetail.preorderDetail.length > 0 && preorderDetail.preorderDetail[0].preorder) {
        dispatch(fetchDeliveryLocations(`?codigo_cliente=${preorderDetail.preorderDetail[0].preorder.clientId}`))
        if (preorderDetail.preorderDetail[0].preorder.prepaymentId && preorderDetail.preorderDetail[0].preorder.prepaymentId !== '')
          dispatch(fetchPrepayment(preorderDetail.preorderDetail[0].preorder.prepaymentId))
      }
      else {
        if (preorderDetail && !preorderDetail.isFetching && preorderDetail.preorderDetail && preorderDetail.preorderDetail.length === 0 && preorderData && !preorderData.isFetching && preorderData.preorder) {
          dispatch(fetchDeliveryLocations(`?codigo_cliente=${preorderData.preorder.clientId}`))
          if (preorderData.preorder.prepaymentId && preorderData.preorder.prepaymentId !== '')
            dispatch(fetchPrepayment(preorderData.preorder.prepaymentId))

        }
      }
    }
  }, [dispatch, preorderDetail, preorderDetail.preorderDetail, preorderData, preorderData.preorder])


  const closeDialog = () => {
    dispatch({ type: 'DELIVERY_CLEAR' })
    setShowCloseDialog(false)
  }

  const handleAttachedFile = async (preorder: Preorder, uploadPreorderFile: any, status: string, files: File[]) => {
    if (files.length === 0) {
      setFetchingUploadFile(false);
      closeDialog()
      //setShowCloseDialog(false)
      history.goBack()
      return
    }
    if (files[0]) {
      const formData = new FormData();
      formData.append("file", files[0]);
      formData.append("fileName", files[0].name);
      dispatch(uploadPreorderFile(formData, preorder.id, async (fileId: string) => {
        switch (status) {
          case 'H': {
            dispatch(upsertPreorder({ ...preorder, attachedFileOnHold: fileId }))
            break;
          }
          case 'R': {
            dispatch(upsertPreorder({ ...preorder, attachedFileOnReject: fileId }))
            break;
          }
        }
        setFetchingUploadFile(false)
        closeDialog()
        //setShowCloseDialog(false)
        history.goBack()
      }))
    }
  }

  const updateInternalRemarks = (newInternalRemarks: string) => {
    const lines = newInternalRemarks.split('\n').map(line => line.slice(0, 50).padEnd(50, ' ')); // Completa con espacios hasta 50 caracteres
    // Máximo 5 líneas de 50 caracteres cada una
    const newLines = lines.slice(0, 5).join('\n')
    return newLines.replaceAll('\n', '')
  }

  const confirmClosePreorder = (preorder: Preorder, files: File[], event: FormEvent) => {
    event.preventDefault()
    setFetchingUploadFile(true);
    if (preorder.internalRemarks)
      preorder.internalRemarks = updateInternalRemarks(preorder.internalRemarks)

    dispatch(upsertPreorder({ ...preorder, ownerClosed: preorder.status !== 'H' ? session?.orionId ?? session?.personId ?? undefined : undefined },
      (preorder) => {
        switch (preorder.status) {
          case 'H': {
            handleAttachedFile(preorder, uploadPreorderHoldFile, preorder.status, files);
            break;
          }
          case 'R': {
            handleAttachedFile(preorder, uploadPreorderRejectFile, preorder.status, files);
            break;
          }
          default: {
            setFetchingUploadFile(false);
            closeDialog()
            //setShowCloseDialog(false)
            history.goBack()
            break;
          }
        }
      }
    ))
  }

  useEffect(() => {
    if (preorderData && !preorderData.isFetching && preorderData.preorder)
      setCurrentPreorder(preorderData.preorder)
  }, [preorderData, preorderData.preorder])

  const allFetched = () => {
    return !preorderDetail.isFetching && !preorderData.isFetching &&
      !carrierList.isFetching &&
      !deliveryLocationList.isFetching &&
      !deliveryAreaList.isFetching &&
      !logisticWarningList.isFetching &&
      !incotermsList.isFetching &&
      !provinceList.isFetching &&
      !localityList.isFetching &&
      !prepayment.isFetching
  }

  const whichNotFetched = (): string[] => {
    const result: string[] = []
    if (!currentPreorder) result.push('currentPreorder')
    if (preorderDetail.isFetching) result.push('preorderDetail')
    if (preorderData.isFetching) result.push('preorderData')
    if (carrierList.isFetching) result.push('carriers')
    if (deliveryLocationList.isFetching) result.push('deliveryLocations')
    if (deliveryAreaList.isFetching) result.push('deliveryAreas')
    if (logisticWarningList.isFetching) result.push('logisticWarnings')
    if (incotermsList.isFetching) result.push('incoterms')
    if (provinceList.isFetching) result.push('provinces')
    if (localityList.isFetching) result.push('localities')
    if (prepayment.isFetching) result.push('prepayments')
    return result
  }


  const downloadFilePreorder = async (preorder: Preorder, fileId: string, fileName: string) => {
    if (preorder.attachedFileOnHold && preorder.id) {
      try {
        setDownloading(`${preorder.id}${fileId}`)
        await dispatch(downloadPreorderFile(preorder.id, fileId,
          (file: any) => {

            const url = URL.createObjectURL(new Blob([file], { type: 'application/pdf' }))
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
              'download',
              fileName ? fileName : `Retencion-Carrito-${preorder.id}.pdf`
            );
            document.body.appendChild(link);
            // Start download
            link.click();

            URL.revokeObjectURL(url);
          }))
        setDownloading('')
      }
      catch {
      }
    }
  }

  const HeaderDetail: React.FC = () => {
    return (
      <Paper elevation={2} sx={{ margin: "10px", padding: "2px 2px 2px 2px", bgcolor: theme.palette.success.main }}>
        {!preorderData.isFetching && !preorderDetail.isFetching && carrierList && carrierList.carriers && !carrierList.isFetching &&
          <Paper elevation={2}
            style={{
              padding: "15px 15px 15px 15px", display: "flex", flexDirection: "column",
              textAlign: "justify", justifyContent: "space-around",
              borderRadius: "4px", margin: "4px"
            }}>
            {preorderData && preorderData.preorder &&
              <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" >
                <Box display="flex" alignItems="center">
                  <Typography fontWeight="bold" variant="h6">{t('number')}:&nbsp;&nbsp;</Typography>
                  <Typography variant="h6">{preorderData.preorder.id}</Typography>
                </Box>
                <Box display="flex" alignItems="center">
                  <Typography fontWeight="bold" variant="h6">{t('date')}:&nbsp;&nbsp;</Typography>
                  <Typography variant="h6">{moment(preorderData.preorder.dateUpdated ? preorderData.preorder.dateUpdated : preorderData.preorder.dateCreated).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</Typography>
                </Box>
                {preorderDetail && preorderDetail.preorderDetail && preorderDetail.preorderDetail.length > 0 && preorderDetail.preorderDetail[0].preorder &&
                  <Box display="flex" alignItems="center">
                    <Typography fontWeight="bold" variant="h6">{t('subtotal')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="h6">
                      {preorderData.preorder && preorderData.preorder.detail && formattedCurrency(preorderData.preorder.detail.reduce((amount, det) => amount + Number(det.amount), 0))}
                    </Typography>
                  </Box>}
              </Box>}
            {preorderData && preorderData.preorder &&
              preorderData.preorder.prepaymentId && preorderData.preorder.prepaymentId !== '' &&
              <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" >
                {preorderData.preorder && preorderData.preorder.prepaymentId &&
                  <Box display="flex" alignItems="center">
                    <Typography fontWeight="bold" variant="h6">{t('prepaymentId')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="h6">&nbsp;&nbsp;{preorderData?.preorder?.prepaymentId}</Typography>
                    {prepayment && prepayment.prepayment && prepayment.prepayment.length > 0 &&
                      <Typography variant="h6">&nbsp;-&nbsp;{prepayment.prepayment[0].descripcion}</Typography>}
                  </Box>}
              </Box>}
            {preorderData && preorderData.preorder &&
              <Box display="flex" justifyContent="flex-start" alignItems="center">
                <Box display="flex" alignItems="center">
                  <Typography fontWeight="bold" variant="h6">{t('status')}:&nbsp;&nbsp;</Typography>
                  <Typography variant="h6">&nbsp;&nbsp;{statusPreorderNameTranslated(preorderData.preorder.status!, t)}</Typography>
                </Box>
              </Box>}
            {preorderData && preorderData.preorder &&
              <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" >
                {preorderData && preorderData.preorder && preorderData.preorder.priceListId &&
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography fontWeight="bold" variant="h6">{t('listPrice')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="body1">
                      {preorderData.preorder.priceListId}
                    </Typography>
                  </Box>}
                {preorderData && preorderData.preorder && preorderData.preorder.clientId &&
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography fontWeight="bold" variant="h6">{t('client')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="body1">
                      {preorderData.preorder.clientId} - {client?.client?.nombrefantasia ?? ''}
                    </Typography>
                  </Box>}
              </Box>}
            {preorderData && preorderData.preorder && preorderData.preorder.remarks &&
              <Box display="flex" justifyContent="flex-start" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('remarksTitle')}:&nbsp;&nbsp;</Typography>
                <Typography variant="body1">
                  {preorderData.preorder.remarks}
                </Typography>
              </Box>}
            {preorderData && preorderData.preorder && preorderData.preorder.internalRemarks &&
              <Box display="flex" justifyContent="flex-start" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('internalRemarksTitle')}:&nbsp;&nbsp;</Typography>
                <Typography variant="body1">
                  {preorderData.preorder.internalRemarks}
                </Typography>
              </Box>}
            {preorderData && preorderData.preorder && preorderData.preorder.holdedRemarks &&
              <Box display="flex" justifyContent="flex-start" alignItems="baseline">
                <Typography fontWeight="bold" sx={{ whiteSpace: 'nowrap', verticalAlign: 'top' }} variant="h6">{t('holdedRemarksTitle')}:&nbsp;&nbsp;</Typography>
                <Typography variant="body1">&nbsp;</Typography>
                <Typography variant="body1">
                  {preorderData.preorder.holdedRemarks}
                </Typography>
                {preorderData.preorder.attachedFileOnHold &&
                  <>
                    <Typography fontWeight="bold" variant="h6">&nbsp;&nbsp;{t('attachedFile')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="body1">{preorderData.preorder.fileNameHolded}
                      <Tooltip title={preorderData.preorder.fileNameHolded ? preorderData.preorder.fileNameHolded : ''}>
                        <IconButton color="secondary"
                          onClick={(e) => {
                            e.stopPropagation(); preorderData && preorderData.preorder &&
                              preorderData.preorder.attachedFileOnHold && preorderData.preorder.fileNameHolded && downloadFilePreorder(preorderData.preorder, preorderData.preorder.attachedFileOnHold, preorderData.preorder.fileNameHolded)
                          }}>
                          {downloading === `${preorderData.preorder.id}${preorderData.preorder.attachedFileOnHold}` ? <CircularProgress size={15} /> : <AttachFile fontSize="small" />}
                        </IconButton>
                      </Tooltip>
                    </Typography>
                  </>}
              </Box>}
            {preorderData && preorderData.preorder && preorderData.preorder.rejectedRemarks &&
              <Box display="flex" justifyContent="flex-start" alignItems="baseline">
                <Typography fontWeight="bold" sx={{ whiteSpace: 'nowrap', verticalAlign: 'top' }} variant="h6">{t('rejectedRemarksTitle')}:&nbsp;&nbsp;</Typography>
                <Typography variant="body1">&nbsp;</Typography>
                <Typography variant="body1">
                  {preorderData.preorder.rejectedRemarks}
                </Typography>
                {preorderData.preorder.attachedFileOnReject &&
                  <>
                    <Typography fontWeight="bold" variant="h6">&nbsp;&nbsp;{t('attachedFile')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="body1">{preorderData.preorder.fileNameRejected}
                      <Tooltip title={preorderData.preorder.fileNameRejected ? preorderData.preorder.fileNameRejected : ''}>
                        <IconButton color="secondary"
                          onClick={(e) => {
                            e.stopPropagation(); preorderData && preorderData.preorder &&
                              preorderData.preorder.attachedFileOnReject && preorderData.preorder.fileNameRejected && downloadFilePreorder(preorderData.preorder, preorderData.preorder.attachedFileOnReject, preorderData.preorder.fileNameRejected)
                          }}>
                          {downloading === `${preorderData.preorder.id}${preorderData.preorder.attachedFileOnReject}` ? <CircularProgress size={15} /> : <AttachFile fontSize="small" />}
                        </IconButton>
                      </Tooltip>
                    </Typography>
                  </>}
              </Box>}
            {preorderData && preorderData.preorder &&
              <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" >
                {preorderData && preorderData.preorder && preorderData.preorder.purchaseOrder &&
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography fontWeight="bold" variant="h6">{t('purchaseOrder')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="body1">{preorderData.preorder.purchaseOrder}</Typography>
                  </Box>}
                {preorderData && preorderData.preorder && preorderData.preorder.warehouse &&
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography fontWeight="bold" variant="h6">{t('warehouse')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="body1">
                      {preorderData.preorder.warehouse}
                    </Typography>
                  </Box>}
              </Box>}
            {preorderData && preorderData.preorder &&
              <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
                {preorderData && preorderData.preorder && preorderData.preorder.dl_address &&
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography fontWeight="bold" variant="h6">{t('delivery')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="body1">
                      {preorderData.preorder.dl_address}
                      {preorderData.preorder.dl_locality ? ` - ${preorderData.preorder.dl_locality}` : ''}
                      {preorderData.preorder.dl_phone ? ` - ${preorderData.preorder.dl_phone}` : ''}
                      {preorderData.preorder.dl_openingHours ? ` - ${preorderData.preorder.dl_openingHours}` : ''}
                    </Typography>
                  </Box>}
                {preorderData && preorderData.preorder && preorderData.preorder.dl_deliveryArea !== undefined && preorderData.preorder.dl_deliveryArea !== 0 &&
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography fontWeight="bold" variant="h6">{t('deliveryArea')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="body1">
                      {preorderData.preorder.dl_deliveryArea}&nbsp;&nbsp;-&nbsp;&nbsp;
                      {carrierList.carriers.find(c => c.codigo_zonadereparto.toString() === preorderData?.preorder?.dl_deliveryArea?.toString())?.zonasdereparto_descripcion}
                    </Typography>
                  </Box>}
              </Box>}
            {preorderData && preorderData.preorder &&
              <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" >
                {preorderData && preorderData.preorder && preorderData.preorder.transportId &&
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography fontWeight="bold" variant="h6">{t('carrier')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="body1">
                      {preorderData.preorder.transportId} - {carrierList?.carriers?.find(c => c.codigo_transporte.toString() === preorderData?.preorder?.transportId!.toString())?.nombre}                    </Typography>
                  </Box>}
                {preorderData && preorderData.preorder && (preorderData.preorder.estimatedDeliveryDate || preorderData.preorder.manualEstimatedDeliveryDate) &&
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography fontWeight="bold" variant="h6">{t('estimatedDeliveryDate')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="body1">
                      {`${moment(preorderData.preorder.manualEstimatedDeliveryDate ? preorderData.preorder.manualEstimatedDeliveryDate : preorderData.preorder.estimatedDeliveryDate).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')} ${preorderData.preorder.manualEstimatedDeliveryDate ? '(M)' : ''}`}
                    </Typography>
                  </Box>}
                {preorderData && preorderData.preorder && preorderData.preorder.carrierArea &&
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography fontWeight="bold" variant="h6">{t('carrierArea')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="body1">
                      {preorderData.preorder.carrierArea}&nbsp;&nbsp;-&nbsp;&nbsp;
                      {carrierList.carriers.find(c => c.codigo_zonadereparto.toString() === preorderData?.preorder?.carrierArea?.toString())?.zonasdereparto_descripcion}
                    </Typography>
                  </Box>}
              </Box>}
            {preorderData && preorderData.preorder &&
              <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" >
                {preorderData && preorderData.preorder && preorderData.preorder.ownerClosed &&
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography fontWeight="bold" variant="h6">{t('ownerCloseName')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="body1">
                      {preorderData.preorder.closedPersonName}
                    </Typography>
                  </Box>}
                {preorderData && preorderData.preorder && preorderData.preorder.dateClosed &&
                  <Box display="flex" justifyContent="flex-start" alignItems="center">
                    <Typography fontWeight="bold" variant="h6">{t('dateClose')}:&nbsp;&nbsp;</Typography>
                    <Typography variant="body1">
                      {moment(new Date(preorderData.preorder.dateClosed)).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}
                    </Typography>
                  </Box>}
              </Box>}
          </Paper>}
        {(preorderData.isFetching || preorderDetail.isFetching || carrierList?.isFetching || fetchingUploadFile) &&
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress size={25} />
          </div>}
      </Paper>
    )
  }

  return (
    <Stack style={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100% - var(--header-height)' }}>
      <HeaderDetail />
      <AdminPreorderDetails
        rows={(preorderDetail.preorderDetail || []).sort((a, b) => a && b ? a.code > b.code ? 1 : -1 : 0)}
        loading={preorderDetail.isFetching && preorderData.isFetching}
        pagination={preorderDetail.pagination || undefined}
      />
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Button color="secondary" variant="contained" sx={{ textTransform: "none", margin: "10px" }} startIcon={<KeyboardReturnOutlined />} onClick={() => history.goBack()}>{t("back", { ns: 'others' })}</Button>

        {preorderDetail && preorderDetail.preorderDetail && preorderDetail.preorderDetail.length > 0 &&
          preorderDetail.preorderDetail[0].preorder && allFetched() &&
          <Tooltip title={t('downloadingPreorder')}>
            <span>
              <Button variant="contained" sx={{ textTransform: "none", margin: "10px" }}
                startIcon={<FileDownloadOutlined />}
                href={`${process.env.REACT_APP_API_URL}/preorders/download/${preorderDetail.preorderDetail[0].preorderId}?access_token=${getToken()}`} target="_blank">
                {t("downloadPreorder")}
              </Button>
            </span>
          </Tooltip>
        }

        {currentPreorder && allFetched() ? (

          <Button variant="contained" sx={{ textTransform: "none", margin: "10px" }}
            disabled={!preorderNotClosingStatus.includes(currentPreorder.status!) || isAdmin(session!) || isManager(session!)}
            startIcon={<FlakyOutlined />} onClick={(e) => { e.stopPropagation(); setShowCloseDialog(true) }}>{t("close")}
          </Button>
        ) : (
          <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1}>
            <Typography variant="body2" sx={{ margin: "8px", color: "primary" }}>
              {t("loadingData")}...
            </Typography>
            {whichNotFetched().map((s: string) => (
              <Chip
                key={s}
                icon={<CircularProgress size={14} />}
                label={t(s)}
                variant="outlined"
                color="primary"
                sx={{ margin: "5px" }}
              />
            ))}
          </Box>)}
      </Box>
      {showCloseDialog &&
        currentPreorder &&
        preorderNotClosingStatus.includes(currentPreorder.status!) &&
        <ClosePreorderDialog preorder={currentPreorder!}
          isUpdating={fetchingUploadFile}
          client={client}
          deliveryLocationList={deliveryLocationList}
          deliveryAreaList={deliveryAreaList}
          logisticWarningList={logisticWarningList}
          provinceList={provinceList}
          incotermsList={incotermsList}
          localityList={localityList}
          carrierList={carrierList}
          session={session}
          total={preorderDetail && preorderDetail.preorderDetail ? preorderDetail.preorderDetail.reduce((amount, det) => amount + Number(det.amount), 0) : 0}
          onConfirm={confirmClosePreorder}
          prepaymentDescription={prepayment && prepayment.prepayment && prepayment.prepayment.length > 0 ? prepayment.prepayment[0].descripcion : ''}
          //onCancel={() => setShowCloseDialog(false)} 
          onCancel={closeDialog}
        />}
    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  preorderDetail: state.preorderDetailList,
  preorderData: state.preorderData,
  prepayment: state.prepaymentDetail,
  carrierList: state.carrierList,
  deliveryLocationList: state.deliveryLocationList,
  deliveryAreaList: state.deliveryAreaList,
  provinceList: state.provinceList,
  logisticWarningList: state.logisticWarningList,
  incotermsList: state.incotermsList,
  localityList: state.localityList,
  client: state.clientDetail,
  session: state.session
})

export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(AdminPreorderDetail);